
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexw3Ne65ygAcMeta } from "/builds/1tool/inspect/pages/camera/index.vue?macro=true";
import { default as _91id_9362aqONYLa3Meta } from "/builds/1tool/inspect/pages/cause-of-damage/[id].vue?macro=true";
import { default as _91id_93qWlCIkwNNCMeta } from "/builds/1tool/inspect/pages/contact/[id].vue?macro=true";
import { default as indexrCxh5LQBTFMeta } from "/builds/1tool/inspect/pages/contacts/create/index.vue?macro=true";
import { default as _91id_93R5dfWSFutHMeta } from "/builds/1tool/inspect/pages/contracts/[id].vue?macro=true";
import { default as indexoU3gG0ZkJCMeta } from "/builds/1tool/inspect/pages/contracts/create/index.vue?macro=true";
import { default as _91id_936KiDVCMqZxMeta } from "/builds/1tool/inspect/pages/damage-mitigation/[id].vue?macro=true";
import { default as _91id_93NTQTEgwd7oMeta } from "/builds/1tool/inspect/pages/damage-report/[id].vue?macro=true";
import { default as indexpXQEThBLJbMeta } from "/builds/1tool/inspect/pages/dashboard/index.vue?macro=true";
import { default as indexAYNczmgLL4Meta } from "/builds/1tool/inspect/pages/events/index.vue?macro=true";
import { default as _91id_93Tu9cYuDvqBMeta } from "/builds/1tool/inspect/pages/extended-damage-report/[id].vue?macro=true";
import { default as _91id_93PaOh58gluoMeta } from "/builds/1tool/inspect/pages/exterior-view/[id].vue?macro=true";
import { default as _91id_93Rbwi5CEPCUMeta } from "/builds/1tool/inspect/pages/forms/[id].vue?macro=true";
import { default as indexctZ0v9gc9zMeta } from "/builds/1tool/inspect/pages/index.vue?macro=true";
import { default as indexvKrDarrytXMeta } from "/builds/1tool/inspect/pages/login/index.vue?macro=true";
import { default as indexWX4w0WLtnfMeta } from "/builds/1tool/inspect/pages/maps/index.vue?macro=true";
import { default as _91id_93VcqKj8CkRdMeta } from "/builds/1tool/inspect/pages/measurement-feedback/[id].vue?macro=true";
import { default as _91id_939v1XcGvymGMeta } from "/builds/1tool/inspect/pages/measurement-protocol/[id].vue?macro=true";
import { default as _91id_93Xh22dPu5vSMeta } from "/builds/1tool/inspect/pages/present-persons/[id].vue?macro=true";
import { default as person_45detailBXkZoxQsxnMeta } from "/builds/1tool/inspect/pages/present-persons/person-detail.vue?macro=true";
import { default as _91id_93nuXTchOXZtMeta } from "/builds/1tool/inspect/pages/preview/[id].vue?macro=true";
import { default as _91id_93WeM4CcZGISMeta } from "/builds/1tool/inspect/pages/project-data/[id].vue?macro=true";
import { default as indexIc6b1P2XV5Meta } from "/builds/1tool/inspect/pages/projects/index.vue?macro=true";
import { default as _91id_93nKejQxuXRsMeta } from "/builds/1tool/inspect/pages/recommended-actions/[id].vue?macro=true";
import { default as _91id_93TeqdmJSAqXMeta } from "/builds/1tool/inspect/pages/recommended-actions/discussed-persons/[id].vue?macro=true";
import { default as _91id_93pzPvzIqyWsMeta } from "/builds/1tool/inspect/pages/recommended-actions/discussed-persons/person-detail/[id].vue?macro=true";
import { default as _91id_934WLQrmT5cGMeta } from "/builds/1tool/inspect/pages/recommended-actions/discussed/[id].vue?macro=true";
import { default as indexYfcRCvHh91Meta } from "/builds/1tool/inspect/pages/reports/index.vue?macro=true";
import { default as _91id_93oI0T0UsknGMeta } from "/builds/1tool/inspect/pages/rss/[id].vue?macro=true";
import { default as _91id_9375EzOyjm7XMeta } from "/builds/1tool/inspect/pages/services/[id].vue?macro=true";
import { default as indexXQIOyfExFWMeta } from "/builds/1tool/inspect/pages/unterminated-projects/index.vue?macro=true";
export default [
  {
    name: "camera",
    path: "/camera",
    component: () => import("/builds/1tool/inspect/pages/camera/index.vue")
  },
  {
    name: "cause-of-damage-id",
    path: "/cause-of-damage/:id()",
    component: () => import("/builds/1tool/inspect/pages/cause-of-damage/[id].vue")
  },
  {
    name: "contact-id",
    path: "/contact/:id()",
    component: () => import("/builds/1tool/inspect/pages/contact/[id].vue")
  },
  {
    name: "contacts-create",
    path: "/contacts/create",
    component: () => import("/builds/1tool/inspect/pages/contacts/create/index.vue")
  },
  {
    name: "contracts-id",
    path: "/contracts/:id()",
    component: () => import("/builds/1tool/inspect/pages/contracts/[id].vue")
  },
  {
    name: "contracts-create",
    path: "/contracts/create",
    component: () => import("/builds/1tool/inspect/pages/contracts/create/index.vue")
  },
  {
    name: "damage-mitigation-id",
    path: "/damage-mitigation/:id()",
    component: () => import("/builds/1tool/inspect/pages/damage-mitigation/[id].vue")
  },
  {
    name: "damage-report-id",
    path: "/damage-report/:id()",
    component: () => import("/builds/1tool/inspect/pages/damage-report/[id].vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/builds/1tool/inspect/pages/dashboard/index.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/builds/1tool/inspect/pages/events/index.vue")
  },
  {
    name: "extended-damage-report-id",
    path: "/extended-damage-report/:id()",
    component: () => import("/builds/1tool/inspect/pages/extended-damage-report/[id].vue")
  },
  {
    name: "exterior-view-id",
    path: "/exterior-view/:id()",
    component: () => import("/builds/1tool/inspect/pages/exterior-view/[id].vue")
  },
  {
    name: "forms-id",
    path: "/forms/:id()",
    component: () => import("/builds/1tool/inspect/pages/forms/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/inspect/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexvKrDarrytXMeta || {},
    component: () => import("/builds/1tool/inspect/pages/login/index.vue")
  },
  {
    name: "maps",
    path: "/maps",
    component: () => import("/builds/1tool/inspect/pages/maps/index.vue")
  },
  {
    name: "measurement-feedback-id",
    path: "/measurement-feedback/:id()",
    component: () => import("/builds/1tool/inspect/pages/measurement-feedback/[id].vue")
  },
  {
    name: "measurement-protocol-id",
    path: "/measurement-protocol/:id()",
    component: () => import("/builds/1tool/inspect/pages/measurement-protocol/[id].vue")
  },
  {
    name: "present-persons-id",
    path: "/present-persons/:id()",
    component: () => import("/builds/1tool/inspect/pages/present-persons/[id].vue")
  },
  {
    name: "present-persons-person-detail",
    path: "/present-persons/person-detail",
    component: () => import("/builds/1tool/inspect/pages/present-persons/person-detail.vue")
  },
  {
    name: "preview-id",
    path: "/preview/:id()",
    component: () => import("/builds/1tool/inspect/pages/preview/[id].vue")
  },
  {
    name: "project-data-id",
    path: "/project-data/:id()",
    component: () => import("/builds/1tool/inspect/pages/project-data/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/builds/1tool/inspect/pages/projects/index.vue")
  },
  {
    name: "recommended-actions-id",
    path: "/recommended-actions/:id()",
    component: () => import("/builds/1tool/inspect/pages/recommended-actions/[id].vue")
  },
  {
    name: "recommended-actions-discussed-persons-id",
    path: "/recommended-actions/discussed-persons/:id()",
    component: () => import("/builds/1tool/inspect/pages/recommended-actions/discussed-persons/[id].vue")
  },
  {
    name: "recommended-actions-discussed-persons-person-detail-id",
    path: "/recommended-actions/discussed-persons/person-detail/:id()",
    component: () => import("/builds/1tool/inspect/pages/recommended-actions/discussed-persons/person-detail/[id].vue")
  },
  {
    name: "recommended-actions-discussed-id",
    path: "/recommended-actions/discussed/:id()",
    component: () => import("/builds/1tool/inspect/pages/recommended-actions/discussed/[id].vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/builds/1tool/inspect/pages/reports/index.vue")
  },
  {
    name: "rss-id",
    path: "/rss/:id()",
    component: () => import("/builds/1tool/inspect/pages/rss/[id].vue")
  },
  {
    name: "services-id",
    path: "/services/:id()",
    component: () => import("/builds/1tool/inspect/pages/services/[id].vue")
  },
  {
    name: "unterminated-projects",
    path: "/unterminated-projects",
    component: () => import("/builds/1tool/inspect/pages/unterminated-projects/index.vue")
  }
]